<div *ngIf="aktiv">
  <div *ngFor="let regel of aktiveRegeln" class="section" [style.background-color]="regel.Aktion.MeldungHintergrundFarbe" [style.color]="regel.Aktion.MeldungTextFarbe">
    <div *ngIf="regel.Aktion.Meldung1">
      <h1>{{ regel.Name }}</h1>
      <div class="preLine">{{ regel.Aktion.Meldung1 }}</div>
    </div>
  </div>
</div>